import React from 'react';
import { Search, X } from 'lucide-react';

const ActiveFilters = ({
  selectedFilters,
  setSelectedFilters,
  searchQuery,
  setSearchQuery,
  clearFilters,
  categories = []
}) => {
  const hasActiveFilters = selectedFilters.category || 
                          selectedFilters.availability !== 'all' || 
                          selectedFilters.maxDistance < 2800 || 
                          searchQuery;

  // Function to get category name by ID
  const getCategoryName = (categoryId) => {
    if (!categoryId) return '';
    if (categoryId === 'uncategorized') return 'Uncategorized';
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.name : categoryId; // Fallback to ID if name not found
  };

  if (!hasActiveFilters) return null;

  return (
    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm font-medium text-blue-800">Active filters:</span>
        
        {searchQuery && (
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
            <Search className="h-3 w-3" />
            "{searchQuery}"
            <button
              onClick={() => setSearchQuery('')}
              className="ml-1 hover:bg-blue-200 rounded-full p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        )}
        
        {selectedFilters.category && (
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
            📁 {getCategoryName(selectedFilters.category)}
            <button
              onClick={() => setSelectedFilters({...selectedFilters, category: ''})}
              className="ml-1 hover:bg-blue-200 rounded-full p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        )}
        
        {selectedFilters.availability !== 'all' && (
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
            📎 {selectedFilters.availability === 'available' ? 'Available Only' : 'Checked Out Only'}
            <button
              onClick={() => setSelectedFilters({...selectedFilters, availability: 'all'})}
              className="ml-1 hover:bg-blue-200 rounded-full p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        )}
        
        {selectedFilters.maxDistance < 2800 && (
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
            📍 ≤ {selectedFilters.maxDistance} miles
            <button
              onClick={() => setSelectedFilters({...selectedFilters, maxDistance: 2800})}
              className="ml-1 hover:bg-blue-200 rounded-full p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        )}
        
        <button
          onClick={clearFilters}
          className="ml-2 px-3 py-1 text-blue-600 hover:text-blue-800 text-sm font-medium hover:underline"
        >
          Clear all
        </button>
      </div>
    </div>
  );
};

export default ActiveFilters;